<template>
  <div class="bidding">
    <banner class="bidding-banner" url="bidding">
      <template slot="buttons">
        <el-button class="banner-button" @click="handleRegister('zhaotoubiao-banner-shiyong')">立即试用</el-button>
        <el-button class="banner-button" @click="this.goConsult">咨询客服</el-button>
      </template>
    </banner>
    <div :class="`bidding-section2 ${specialStyle2}`">
      <div class="section2-content">
        <h1>超越传统招投标，扩源易用，优化招标过程</h1>
        <p>甄云招投标系统，聚焦多组织中大型企业，以
          “整合、实用，开放”三大特性持续优化企业招投标过程，提升采购性价比，规范招采流程，达到降本增效。服务涵盖：多渠道信息发布、供应商甄选、招标创建及开标、专家库建立、竞价模式、询比价管理、图形化评标报告、招标进度监控及预警、防止围标、电子签章等全场景服务，帮助企业实现更强的议价能力，
          更全面的招采掌控，提升企业数字化能力。</p>
        <div slot="buttons">
          <el-button class="banner-button" @click="handleRegister('zhaotoubiao-chanpin-yanshi')">预约演示
            <img src="../../assets/img/bidding/icon_demo.svg" alt="预约演示">
          </el-button>
        </div>
        <img class="section2-img" alt="超越传统招投标" src="../../assets/img/bidding/illustrator_keyword.svg"/>
      </div>
    </div>
    <div :class="`bidding-section3 ${specialStyle3}`">
      <div class="section3-content">
        <h1>产品特色</h1>
        <div class="section3-list">
          <div class="section3-item" v-for="(item, index) in section3List" :key="index">
            <img :src="item.imgUrl" :alt="item.title">
            <h2>{{item.title}}</h2>
            <p>{{item.content}}</p>
          </div>
        </div>
        <div class="section3-button">
          <el-button class="banner-button" @click="handleRegister('zhaotoubiao-tese-shiyong')">立即试用</el-button>
          <el-button class="banner-button" @click="this.goConsult">咨询客服</el-button>
        </div>
      </div>
    </div>
    <div class="bidding-section4">
      <h1>面向招采需求的核心应用</h1>
      <div :class="`section4-content ${specialStyle4.item1}`">
        <div>
          <h1>多模式覆盖招投标全过程</h1>
          <div class="content-item">
            <h2>招标计划及项目维护</h2>
            <span>招标书创建、多种价格策略、多种合同模板、开标中标等全流程</span>
          </div>
          <div class="content-item">
            <h2>供应商严选，降低采购风险</h2>
            <span>设有供应商注册、认证、初审、考察、评审等筛选机制</span>
          </div>
          <div class="content-item">
            <h2>专家评分管理，确保科学公正</h2>
            <span>集团级专家库管理， 严把专家准入关</span>
          </div>
        </div>
        <img class="item-img" alt="覆盖招投标全过程" src="../../assets/img/bidding/illustrator_coreapp_01.svg">
      </div>
      <div :class="`section4-content ${specialStyle4.item2}`" style="margin-top: 165px !important;">
        <img class="item-img" alt="竞价模式多样" src="../../assets/img/bidding/illustrator_coreapp_02.svg">
        <div>
          <h1>竞标模式多样，带来降本效应</h1>
          <div class="content-item">
            <h2>竞价模式</h2>
            <span>供应商之间相互竞价，提升降价空间，还价历史清晰可查</span>
          </div>
          <div class="content-item">
            <h2>询比价管理 </h2>
            <span>允许多轮还比价，完整记录整个过程，且可自动导入ERP</span>
          </div>
        </div>
      </div>
      <div :class="`section4-content ${specialStyle4.item3}`" style="margin-top: 165px !important;">
        <div>
          <h1>招标全流程的进度监控及预警</h1>
          <div class="content-item">
            <h2>预警自定义设置，有效监控</h2>
            <span>实现事前待办提醒 、流程节点通知 、故障报告等</span>
          </div>
          <div class="content-item">
            <h2>统一移动应用平台</h2>
            <span>预警通过邮件、微信、邮箱等终端触达，实时提醒</span>
          </div>
        </div>
        <img class="item-img" alt="招标全过程监控可查" src="../../assets/img/bidding/illustrator_coreapp_03.svg">
      </div>
      <div :class="`section4-content ${specialStyle4.item4}`" style="margin-top: 182px !important;">
        <img class="item-img" alt="招投标拓展功能" src="../../assets/img/bidding/illustrator_coreapp_04.svg">
        <div>
          <h1>拓展功能提升体验，让业务更顺畅</h1>
          <div class="content-item">
            <h2>集成具有CA认证的第三方电子签章系统</h2>
            <span>标书生成PDF时自动嵌入电子签章，实现对标书的加密及管理</span>
          </div>
          <div class="content-item">
            <h2>通过投标情况对比，自动预警围串标风险</h2>
            <span>通过对供应商IP地址历史对比、标书雷同、以及录音录像三步走，自动破解围串标风险</span>
          </div>
        </div>
      </div>
      <div class="section4-button">
        <el-button class="banner-button" @click="handleRegister('zhaotoubiao-hexin-gengduo')">了解更多</el-button>
      </div>
    </div>
    <div class="bidding-section5">
      <h1>助力众多行业的领军企业</h1>
      <div class="section5-content">
        <div class="section5-item" v-for="(item, index) in caseData" :key="index">
          <img v-lazy="$global.globalPath + item.bidding_img" :alt="item.title"/>
        </div>
      </div>
      <p><a href="/clientele" target="_blank">查看更多客户案例 ></a></p>
    </div>
    <div class="bidding-section6">
      <h1>客户感言</h1>
      <speech-swiper :mark="2"></speech-swiper>
    </div>
  </div>
</template>
<script>
import hoverButton from '../common/hoverButton.vue'
import banner from '../common/banner.vue'
import SpeechSwiper from '../common/speechSwiper.vue'

export default {
  inject: ['openRegister', 'goConsult'],
  components: {
    hoverButton,
    banner,
    SpeechSwiper
  },
  name: 'Bidding',
  data () {
    return {
      section3List: [
        {
          imgUrl: require('../../assets/img/bidding/icon_01.svg'),
          title: '寻源丰富实现降本',
          content: '聚集各部门需求、按需询价、竞价、招投标、竞争性谈判、支持多平台招标发布、扩大招标范围，满足企业不同采购需求。'
        },
        {
          imgUrl: require('../../assets/img/bidding/icon_02.svg'),
          title: '功能完善减少开发',
          content: '涵盖电子招投标业务的全过程，行业广泛适用，平台功能完备，高度灵活，可自由选配，避免重复建设。'
        },
        {
          imgUrl: require('../../assets/img/bidding/icon_03.svg'),
          title: '预警提醒增强掌控',
          content: '关键节点自动预警提醒、违规行为自动监控，及时纠正。全过程电子化网上留痕、可溯可查、短信、微信、邮件全终端触达。'
        },
        {
          imgUrl: require('../../assets/img/bidding/icon_04.svg'),
          title: '开放接口多方协同',
          content: '采用一系列标准化接口，可与其他外部系统互联互通，数据共享，目前已集成电子签章系统、ERP、OA等功能。'
        }],
      partnerData: [],
      caseData: [],
      specialStyle2: '',
      specialStyle3: '',
      specialStyle4: { item1: '', item2: '', item3: '', item4: '' }
    }
  },
  methods: {
    // 客户案例
    getCaseData () {
      this.$api.post('/cases/get_cases', { webname: 'bidding', cases_sum: 15 }, (r) => {
        if (r.code === 0) {
          this.caseData = r.data
        } else {
          this.$message.error(r.message)
        }
      })
    },
    // 跳转注册
    handleRegister (code) {
      this.openRegister(false, code)
    },
    // 特效计算高度
    handleScroll () {
      let top = Math.floor(document.body.scrollTop || document.documentElement.scrollTop || window.pageXOffset)
      if (top > 100) {
        this.specialStyle2 = 'special-section2'
      }
      if (top >= 500) {
        this.specialStyle3 = 'special-section3'
      }
      if (top >= 1300) {
        this.specialStyle4.item1 = 'special-section4-item1'
      }
      if (top >= 1700) {
        this.specialStyle4.item2 = 'special-section4-item2'
      }
      if (top >= 2200) {
        this.specialStyle4.item3 = 'special-section4-item3'
      }
      if (top >= 2700) {
        this.specialStyle4.item4 = 'special-section4-item4'
      }
    }
  },
  mounted () {
    this.getCaseData()
    this.$nextTick(() => {
      window.addEventListener('scroll', this.handleScroll, true)
    })
  }
}
</script>
<style lang="scss">
  @import "../../../static/css/bidding.scss";
  @import "../../../static/css/common.scss";
</style>



// WEBPACK FOOTER //
// bidding.vue?656694ff